@defer (on timer(100ms)) {
    @if (options() && options().length > 0) {
        <section
            appScrollGuide
            [scrollEnabled]="scrollEnabled()"
            [class.border-none]="noBorder()"
            #container
            class="flex overflow-y-visible relative w-full border-b theme-border"
            (scroll)="handleScroll($event)"
            [class.overflow-x-auto]="scrollEnabled()"
        >
            @for (
                option of options();
                track $index;
                let first = $first;
                let last = $last
            ) {
                <div
                    class="min-w-max"
                    segmentOption
                    #item
                    (click)="handleClick(option)"
                    [active]="value() === option.value"
                    [option]="option"
                    [color]="color()"
                ></div>
            }

            <div
                #indicator
                [attr.data-color]="color()"
                class="absolute transition-all duration-300 ease-in-out indicator"
                style="height: 0.15rem"
                [style.bottom]="scrollEnabled() ? 0 : '-0.15rem'"
            ></div>
        </section>
    }
}
